import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, toHandlers as _toHandlers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "grid grid-cols-1 gap-6"
}
const _hoisted_2 = { class: "flex flex-col md:flex-row gap-4" }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-gray-500 mb-4" }, "Periodicidade", -1)
const _hoisted_5 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6" }
const _hoisted_6 = { class: "mt-2 flex flex-col gap-4" }
const _hoisted_7 = { class: "text-left text-sm text-[#68688D] -mt-3" }
const _hoisted_8 = { class: "flex w-full gap-4" }
const _hoisted_9 = {
  key: 0,
  class: "w-1/4"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_12 = {
  class: "text-sm text-left text-textPrimary",
  "data-testid": "management-doctor-summary"
}
const _hoisted_13 = { class: "flex flex-col md:flex-row gap-4" }
const _hoisted_14 = { class: "flex flex-col text-textPrimary" }
const _hoisted_15 = {
  key: 0,
  class: "text-sm bg-warning/20 border border-warning rounded-md px-4 py-1 mb-4"
}
const _hoisted_16 = { class: "bg-gray-200 rounded px-2 border border-gray-500 ml-4" }
const _hoisted_17 = {
  key: 1,
  class: "text-sm bg-negative/10 border border-negative rounded-md px-4 py-2 mb-4 flex items-center gap-2 text-[#DA1E28]"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Uma ou mais vagas selecionadas têm horários sobrepostos, ocorrendo conflito de alocação", -1)
const _hoisted_19 = { class: "grid grid-cols-2 gap-x-4 gap-y-2 text-left text-sm md:text-base" }
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Empresa", -1)
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Escala", -1)
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Unidade", -1)
const _hoisted_26 = { class: "flex flex-col" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Posição", -1)
const _hoisted_28 = { class: "flex flex-col" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Turno", -1)
const _hoisted_30 = { class: "flex flex-col" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Fuso horário", -1)
const _hoisted_32 = {
  key: 1,
  class: "flex flex-col items-center justify-center text-center py-10"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-gray-600" }, " Nenhum plantão encontrado com os parâmetros selecionados. ", -1)
const _hoisted_34 = { class: "p-4" }
const _hoisted_35 = {
  key: 0,
  class: "flex flex-col-reverse md:flex-row gap-3 justify-between w-full"
}
const _hoisted_36 = {
  key: 0,
  class: "flex flex-col-reverse md:flex-row gap-3 justify-between w-full"
}
const _hoisted_37 = {
  key: 1,
  class: "flex justify-center w-full"
}

import { ref, computed, PropType, watch, toRef } from 'vue'
import { storeToRefs } from 'pinia'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import { DatePicker } from 'v-calendar'
import 'v-calendar/style.css'
import { mdiAlertCircleOutline, mdiCalendar } from '@mdi/js'
import { format, endOfDay } from 'date-fns'

import { useDoctorStore } from '@/pinia-store/useDoctorStore'
import DsPaymentFormationService from '@/Network/Services/DsPaymentFormationService'
import ScheduleUnitService from '@/Network/Services/ScheduleUnitService'
import StationService from '@/Network/Services/StationService'
import { ShiftDetails, StationFormSchedule } from '@/Network/Types/Responses/StationResponses'
import {
  ListStationsFromScheduleRequest,
  PatchStationsFromSchedulePayload,
  StationTypes
} from '@/Network/Types/Requests/StationRequests'

import ModalVue from '@/components/designSystem/modals/Modal.vue'
import SelectableCard from '@/components/designSystem/Cards/SelectableCard.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import CardDutyWithDoctor from '@/components/designSystem/Cards/CardDutyWithDoctor.vue'
import ManagementDoctorTable from '../../components/ManagementDoctorTable.vue'
import ExpandedTableModal from '../../components/ExpandedTableModal.vue'
import OptionSelect from '@/components/designSystem/Select/OptionSelect.vue'
import Spinner from '@/components/others/Spinner.vue'

import {
  dayMapping,
  dayOptions,
  periodicity,
  recurrence,
  recurrenceDescriptions,
  repetition,
  tableHeaders,
  weekMapping,
  weekOptions
} from '../utils/data'
import { useStationStore } from '@/pinia-store/useStationStore'
import { CompanyDoctorInviteStatusEnum } from '@/Network/Types/Requests/CompanyRequests'
import { useExpandedTable, useInitialPage, useSummaryText } from '../utils/modalUtils'
import ActionModalHeader from '../../components/ActionModalHeader.vue'
import ConsecutiveHoursBlockAlert from '@/components/designSystem/Alerts/ConsecutiveHoursBlockAlert.vue'
import { useConsecutiveHoursCheck } from '@/hooks/useConsecutiveHoursCheck'
import type { ConsecutiveHoursCheckCandidate } from '@/Network/Types/Requests/StationRequests'
import {
  getPostStationApprovedMessage,
  isPostStationApprovedError
} from '@/modules/company/PostStation/errors'
import CoverageModeSelector from '@/components/Coverage/CoverageModeSelector.vue'
import { useUnidentifiedCoverageLock } from '@/components/Coverage/useUnidentifiedCoverageLock'
import CoverageResponsibleField from '@/components/Coverage/CoverageResponsibleField.vue'
import CoverageTransitionConfirmModal from '@/components/Coverage/CoverageTransitionConfirmModal.vue'
import CoveragePreviewSummary from '../../components/CoveragePreviewSummary.vue'
import { CoverageMode } from '@/Network/Types/Requests/CoverageRequests'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'
import {
  canMarkUnidentified,
  getStationCoverageInfo,
  scheduleSupportsCoverage
} from '@/utils/coverage'
import { getCoverageErrorMessage } from '@/utils/coverageErrors'
import PlaceholderDoctorBlockedModal from '@/components/Coverage/PlaceholderDoctorBlockedModal.vue'
import { usePlaceholderDoctorBlocked } from '@/composables/usePlaceholderDoctorBlocked'
import {
  findDoctorTitle,
  focusCoverageResponsibleSelect,
  focusFieldBySelector,
  isBlockedPlaceholderDoctor,
  reportPreventivePlaceholderAttempt
} from '@/utils/placeholderDoctor'
import {
  buildCoverageOperations,
  buildCoveragePatchStations,
  buildCoveragePlan,
  buildTransitionSummary,
  coverageTableHeaders,
  formatLegacyAvailability,
  needsTransitionConfirmation,
  toPreviewTableRow
} from '../utils/coverageAllocation'

const INDISPONIVEL = 'indisponível'


export default /*#__PURE__*/_defineComponent({
  __name: 'management.doctor.modal',
  props: {
  showModal: {
    type: Boolean,
    required: true
  },
  stationDetails: {
    type: Object as PropType<ShiftDetails | null>,
    default: () => null
  },
  mode: {
    type: String as PropType<'allocate' | 'change'>,
    required: true
  },
  // "Editar responsável" abre direto em "Ocupado sem identificação"; null = "Médico".
  initialCoverage: {
    type: String as PropType<CoverageMode | null>,
    default: null
  }
},
  emits: ['closeModal', 'allocationUpdated'],
  setup(__props, { emit }) {

const props = __props;

let searchDebounceTimer: number | undefined = undefined





const toast = useToast()
const { notifyError } = useErrorToast()
const doctorStore = useDoctorStore()
const stationService = new StationService()
const { listDoctorsCompany } = storeToRefs(doctorStore)
const stationStore = useStationStore()

const isThisModalVisible = ref(props.showModal)
const isExpandedTableModalOpen = ref(false)
const showShiftList = ref(false)
const isLoadingDoctors = ref(false)
const isLoadingFormations = ref(false)
const isLoadingAllocators = ref(false)
const isLoadingShifts = ref(false)
const isLoadingSubmit = ref(false)

const doctors = ref<{ title: string; value: any; subtitle: string }[]>([])
const formations = ref<{ title: string; value: string | number }[]>([])
const teams = ref([
  { title: 'Interno', value: 'internal' },
  { title: 'Externo', value: 'external' }
])
const allocators = ref<{ title: string; value: string | number }[]>([])
const shifts = ref<StationFormSchedule[]>([])
const totalShiftsCount = ref(0)
const openShiftsCount = ref(0)
const closedShiftsCount = ref(0)
// `countUnregistered` do BE: ocupado sem identificação saiu de `countOpen` (null = BE antigo).
const unregisteredShiftsCount = ref<number | null>(null)
const conflictShiftsCount = ref(0)

const selectedDoctor = ref<string | null>(null)
const selectedFormation = ref<number | null>(null)
const selectedTeam = ref<string | null>(null)
const selectedAllocator = ref<number | null>(null)
const selectedPeriodicity = ref<string | null>('COBERTURA')
const selectedRecurrence = ref('unique')
const selectedRepetition = ref('end_scale')
const selectedWeeks = ref(['A', 'C'])
const selectedDay = ref(['seg'])
const startDate = ref()

const coverageMode = ref<CoverageMode>(CoverageMode.DOCTOR)
const coverageResponsibleId = ref<number | null>(null)
const coverageNote = ref('')
const selectedResponsibleName = ref<string | null>(null)
const isTransitionModalOpen = ref(false)

// Aviso do médico "coringa" (PLACEHOLDER_DOCTOR_BLOCKED): 422 do BE ou bloqueio preventivo.
const placeholderBlocked = usePlaceholderDoctorBlocked()
// Aviso aberto pela seleção no autocomplete: ao fechar ("Entendi"/ESC), o foco volta ao médico.
let focusDoctorOnClose = false
watch(placeholderBlocked.isOpen, (open) => {
  if (open || !focusDoctorOnClose) return
  focusDoctorOnClose = false
  void focusFieldBySelector('[data-testid="management-doctor-select"]')
})

// Seleção de médico: um "coringa" bloqueado nesta escala abre o aviso na hora e NÃO é aceito
// (o autocomplete é controlado, então o valor volta ao anterior).
function onDoctorSelected(value: string | null) {
  const schedule = props.stationDetails?.schedule
  if (isBlockedPlaceholderDoctor(schedule, value)) {
    placeholderBlocked.open(findDoctorTitle(doctors.value, value))
    focusDoctorOnClose = true
    reportPreventivePlaceholderAttempt(
      (payload) => stationService.reportPlaceholderAllocationAttempt(payload),
      {
        doctorId: Number(value),
        scheduleId: Number(schedule?.id),
        stationIds: props.stationDetails?.id ? [props.stationDetails.id] : undefined
      }
    )
    return
  }
  selectedDoctor.value = value
}

// "Usar Ocupado sem identificação": volta ao formulário já em UNIDENTIFIED, sem médico.
function onUseUnidentified() {
  // O primário leva o foco ao responsável (o campo de médico some com UNIDENTIFIED).
  focusDoctorOnClose = false
  coverageMode.value = CoverageMode.UNIDENTIFIED
  selectedDoctor.value = null
  showShiftList.value = false
  shifts.value = []
  void focusCoverageResponsibleSelect()
}

const scheduleSupports = computed(() => scheduleSupportsCoverage(props.stationDetails?.schedule))
const allowUnidentified = computed(() => canMarkUnidentified(props.stationDetails?.schedule))
const { unidentifiedLocked, canOpenScheduleSettings, openScheduleSettings } =
  useUnidentifiedCoverageLock(() => props.stationDetails?.schedule)
const originCoverage = computed(() => getStationCoverageInfo(props.stationDetails))
const isDoctorTarget = computed(() => coverageMode.value === CoverageMode.DOCTOR)
const coveragePlan = computed(() => buildCoveragePlan(shifts.value, coverageMode.value))
const transitionSummary = computed(() => buildTransitionSummary(coveragePlan.value))
const previewHeaders = computed(() =>
  coveragePlan.value.hasContract ? coverageTableHeaders : tableHeaders
)

const modalTitle = computed(() => {
  if (originCoverage.value.status === CoverageStatus.UNIDENTIFIED) {
    return coverageMode.value === CoverageMode.UNIDENTIFIED
      ? 'Editar responsável'
      : 'Identificar médico'
  }
  return props.mode === 'change' ? 'Alterar médico' : 'Alocar médico'
})

// Com contrato e nenhuma linha aplicável (todas bloqueadas) não há o que enviar (M6-C).
const isSubmitBlocked = computed(
  () => coveragePlan.value.hasContract && coveragePlan.value.applicableRows.length === 0
)

const pluralizeStations = (n: number) => `${n} ${n === 1 ? 'plantão' : 'plantões'}`

const submitLabel = computed(() => {
  // M4: com a prévia de cobertura o botão diz em quantos plantões vai aplicar.
  if (coveragePlan.value.hasContract) {
    const n = coveragePlan.value.applicableRows.length
    return n > 0 ? `Aplicar em ${pluralizeStations(n)}` : 'Aplicar'
  }
  if (isDoctorTarget.value) return 'Confirmar alocação'
  return needsTransitionConfirmation(coveragePlan.value) ? 'Continuar' : 'Confirmar'
})

const transitionContextLabel = computed(() => {
  const recurrenceTitle = recurrence.find((r) => r.value === selectedRecurrence.value)?.title
  const path = [
    props.stationDetails?.schedule?.healthUnit?.name,
    props.stationDetails?.schedule?.name,
    props.stationDetails?.position?.name
  ]
    .filter(Boolean)
    .join(' › ')
  return [recurrenceTitle, path].filter(Boolean).join(' · ')
})

// `initialCoverage` só vale se a escala permitir o modo pedido; senão abre em "Médico".
function resolveInitialCoverage(): CoverageMode {
  const requested = props.initialCoverage
  if (requested === CoverageMode.UNIDENTIFIED && allowUnidentified.value) return requested
  if (requested === CoverageMode.OPEN && scheduleSupports.value) return requested
  return CoverageMode.DOCTOR
}

const SUCCESS_MESSAGES: Record<CoverageMode, string> = {
  [CoverageMode.DOCTOR]: 'Alocação confirmada com sucesso!',
  [CoverageMode.UNIDENTIFIED]: 'Plantões marcados como ocupados sem identificação.',
  [CoverageMode.OPEN]: 'Vagas liberadas com sucesso.'
}

const {
  violations: consecutiveHoursViolations,
  hasViolations: hasConsecutiveHoursViolations,
  runCheck: runConsecutiveHoursCheck,
  applyErrorViolations: applyConsecutiveHoursError,
  clearViolations: clearConsecutiveHoursViolations
} = useConsecutiveHoursCheck()

watch([selectedDoctor, selectedTeam, shifts], () => clearConsecutiveHoursViolations())
watch(coverageMode, () => clearConsecutiveHoursViolations())

// Operação em massa: TODOS os plantões listados vão no mesmo lote — tudo-ou-nada.
function buildConsecutiveHoursCandidates(): ConsecutiveHoursCheckCandidate[] {
  const doctorId = selectedDoctor.value ? Number(selectedDoctor.value) : null
  const scheduleId = Number(props.stationDetails?.schedule?.id)
  if (!doctorId || !Number.isFinite(scheduleId)) return []

  // Com o contrato de cobertura, só os plantões que serão alterados entram na checagem:
  // linhas bloqueadas (IGNORED) não podem gerar falso positivo de horas consecutivas.
  const stations = coveragePlan.value.hasContract
    ? coveragePlan.value.applicableRows.map((row) => row.station)
    : shifts.value

  return stations.map((shift) => ({
    scheduleId,
    doctorId,
    stationId: shift.stationId,
    startHour: new Date(shift.startTime).toISOString(),
    endHour: new Date(shift.endTime).toISOString(),
    ourTeam: selectedTeam.value === 'internal',
    timezone: props.stationDetails?.timezone ?? '',
    excludeDoctorStationIds: shift.doctorStationId ? [shift.doctorStationId] : undefined
  }))
}

const { handleExpandTable, handleCloseExpandedTable } = useExpandedTable(
  isThisModalVisible,
  isExpandedTableModalOpen
)

const isLoading = computed(
  () => isLoadingDoctors.value || isLoadingFormations.value || isLoadingAllocators.value
)

const isViewShiftsButtonEnabled = computed(() => {
  if (coverageMode.value === CoverageMode.UNIDENTIFIED) return !!coverageResponsibleId.value
  if (coverageMode.value === CoverageMode.OPEN) return true
  return !!selectedDoctor.value && !!selectedTeam.value && !!selectedAllocator.value
})

const computedDoctorDetails = computed(() => {
  const doctor = doctors.value.find((d) => d.value === selectedDoctor.value)
  const formation = formations.value.find((f) => f.value === selectedFormation.value)
  const team = teams.value.find((t) => t.value === selectedTeam.value)

  return {
    name: doctor ? doctor.title : 'Médico não selecionado',
    crm: doctor ? doctor.subtitle : INDISPONIVEL,
    formation: formation ? formation.title : INDISPONIVEL,
    team: team ? team.title : INDISPONIVEL
  }
})

const computedRecurrenceDescription = computed(() => {
  return (
    recurrenceDescriptions[selectedRecurrence.value as keyof typeof recurrenceDescriptions] || ''
  )
})

const initialPage = useInitialPage(toRef(props, 'stationDetails'))

const ALL_BLOCKED_MESSAGES: Record<CoverageMode, string> = {
  [CoverageMode.DOCTOR]:
    'Nenhum plantão pode ser alterado: todos os selecionados estão bloqueados.',
  [CoverageMode.UNIDENTIFIED]:
    'Nenhum plantão pode ser marcado como ocupado sem identificação: todos os selecionados estão bloqueados.',
  [CoverageMode.OPEN]:
    'Nenhum plantão pode ser liberado como vaga aberta: todos os selecionados estão bloqueados.'
}

const doctorNameToUse = computed(() => computedDoctorDetails.value.name)
const summaryText = computed(() => {
  if (!coveragePlan.value.hasContract) {
    return useSummaryText(doctorNameToUse, totalShiftsCount, 'management')
  }
  // Com contrato conta só as linhas aplicáveis (bloqueadas ficam de fora), como a prévia.
  const applicable = coveragePlan.value.applicableRows
  const n = applicable.length
  if (n === 0) return ALL_BLOCKED_MESSAGES[coverageMode.value]
  if (isDoctorTarget.value) return useSummaryText(doctorNameToUse, ref(n), 'management')
  if (coverageMode.value === CoverageMode.OPEN)
    return `Você está liberando ${pluralizeStations(n)} como vaga aberta. Deseja continuar?`
  // Já ocupado sem identificação + modo Ocupado = só troca o responsável ("Editar responsável").
  const swapping = applicable.filter((r) => r.status === CoverageStatus.UNIDENTIFIED).length
  const marking = n - swapping
  if (marking === 0)
    return `Você está trocando o responsável de ${pluralizeStations(swapping)}. Deseja continuar?`
  const markingText = `Você está marcando ${pluralizeStations(marking)} como ocupado sem identificação`
  return swapping > 0
    ? `${markingText} e trocando o responsável de ${pluralizeStations(swapping)}. Deseja continuar?`
    : `${markingText}. Deseja continuar?`
})

const formattedShifts = computed(() => {
  if (coveragePlan.value.hasContract) return coveragePlan.value.rows.map(toPreviewTableRow)
  return shifts.value.map((station) => ({
    id: `#${station.stationId}`,
    startDate: format(new Date(station.startDate), 'dd/MM/yyyy'),
    startTime: format(new Date(station.startTime), 'HH:mm'),
    endDate: format(new Date(station.endDate), 'dd/MM/yyyy'),
    endTime: format(new Date(station.endTime), 'HH:mm'),
    availability: formatLegacyAvailability(station),
    value: station.value ? `R$${station.value.toFixed(2).replace('.', ',')}` : INDISPONIVEL
  }))
})

const limitedFormattedShifts = computed(() => formattedShifts.value.slice(0, 3))

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
const buildDoctorStationsFilters = (): ListStationsFromScheduleRequest | null => {
  if (!props.stationDetails?.schedule?.id) return null
  if (isDoctorTarget.value && !selectedDoctor.value) return null
  // Backend com a feature recebe o alvo da cobertura para calcular bloqueios do preview.
  const coverageFilter = scheduleSupports.value ? { coverage: coverageMode.value } : {}

  if (selectedRecurrence.value === 'unique') {
    const filters: ListStationsFromScheduleRequest = {
      schedule: props.stationDetails.schedule.id,
      station: props.stationDetails.id
    }

    if (isDoctorTarget.value) filters.doctor = Number(selectedDoctor.value)
    return { ...filters, ...coverageFilter }
  }

  const sDate = new Date(props.stationDetails.startHour)
  let eDate: Date | undefined

  if (selectedRepetition.value === 'personalized' && startDate.value) {
    eDate = endOfDay(startDate.value)
  }

  if (selectedRepetition.value === 'end_scale' && props.stationDetails.schedule.endDate) {
    eDate = new Date(props.stationDetails.schedule.endDate)
  }

  const weekDays = selectedDay.value.map((day) => dayMapping[day]).join(',')

  let weekOfMonth = '0,1,2,3,4,5'

  let fortnightlyFilters = {}

  if (selectedRecurrence.value === 'fortnightly') {
    fortnightlyFilters = {
      alternatingWeek: true,
      stationWeekParity: props.stationDetails.stationWeekParity
    }
  }

  if (selectedRecurrence.value === 'abcde') {
    weekOfMonth = selectedWeeks.value.map((week) => weekMapping[week]).join(',')
  }

  const filters: ListStationsFromScheduleRequest = {
    schedule: props.stationDetails.schedule.id,
    position: props.stationDetails?.position?.id,
    shifts: props.stationDetails?.shift?.id,
    startDate: sDate.toISOString(),
    weekDays: weekDays,
    weekOfMonth: weekOfMonth,
    ...fortnightlyFilters
  }

  if (eDate) {
    filters.endDate = eDate.toISOString()
  }

  if (isDoctorTarget.value && selectedDoctor.value) {
    filters.doctor = Number(selectedDoctor.value)
  }

  return { ...filters, ...coverageFilter }
}

const shouldShowInitialStationWarning = computed(() => {
  if (!props.stationDetails?.id) return false
  return !shifts.value.some((shift) => shift.stationId === props.stationDetails?.id)
})

const hasConflictingStations = computed(() => {
  return conflictShiftsCount.value > 0
})

async function handleViewDoctorStations() {
  const baseFilters = buildDoctorStationsFilters()
  if (!baseFilters) {
    toast.error('Detalhes da escala não encontrados para buscar os plantões.')
    return
  }

  isLoadingShifts.value = true
  shifts.value = []
  try {
    const response = await stationService.listStationsFromSchedule({
      ...baseFilters,
      excludeHasCheckIn: true
    })

    shifts.value = response.stations
    totalShiftsCount.value = response.count
    openShiftsCount.value = response.countOpen
    closedShiftsCount.value = response.countClosed
    unregisteredShiftsCount.value = response.countUnregistered ?? null
    conflictShiftsCount.value = response.countConflict
    showShiftList.value = true
  } catch (error) {
    notifyError(error, 'Não foi possível carregar a lista de plantões')
    console.error(error)
  } finally {
    isLoadingShifts.value = false
  }
}

async function submitAllocation() {
  if (isDoctorTarget.value) {
    const isValidDoctor =
      !!selectedDoctor.value && doctors.value.some((d) => d.value === selectedDoctor.value)
    if (!isValidDoctor) {
      toast.error('Selecione um médico válido antes de confirmar a alocação.')
      return
    }
  } else if (coverageMode.value === CoverageMode.UNIDENTIFIED && !coverageResponsibleId.value) {
    toast.error('Selecione o responsável pela cobertura.')
    return
  }

  // M6: médico real → sem identificação (ou lote todo bloqueado) passa pela confirmação.
  if (needsTransitionConfirmation(coveragePlan.value)) {
    isTransitionModalOpen.value = true
    return
  }
  await executeAllocation()
}

async function handleTransitionConfirm() {
  // M6 só fecha quando o lote foi aplicado; em falha fica aberto junto do toast de erro.
  const succeeded = await executeAllocation()
  if (succeeded) isTransitionModalOpen.value = false
}

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
async function executeAllocation(): Promise<boolean> {
  isLoadingSubmit.value = true
  let succeeded = false
  try {
    const missingDoctorFields =
      isDoctorTarget.value &&
      (!selectedDoctor.value || !selectedTeam.value || !selectedAllocator.value)
    if (shifts.value.length === 0 || missingDoctorFields) {
      toast.error('Por favor, preencha todos os campos e visualize os plantões antes de confirmar.')
      return false
    }

    if (isDoctorTarget.value) {
      const canProceed = await runConsecutiveHoursCheck(buildConsecutiveHoursCandidates())
      if (!canProceed) {
        toast.error('Limite de horas consecutivas excedido. Nenhum plantão foi alterado.')
        return false
      }
    }

    const plan = coveragePlan.value
    const operations = buildCoverageOperations(plan, {
      fallbackOriginDoctorId: props.stationDetails?.doctorStation.doctor?.id ?? null,
      packageId: props.stationDetails?.doctorStation.package?.id ?? null
    })
    if (operations.length === 0) {
      toast.error('Nenhum plantão pode ser alterado com os parâmetros selecionados.')
      return false
    }

    const payload: PatchStationsFromSchedulePayload = {
      operations,
      patchStations: buildCoveragePatchStations({
        target: coverageMode.value,
        hasContract: plan.hasContract,
        doctorId: selectedDoctor.value ? Number(selectedDoctor.value) : null,
        ourTeam: selectedTeam.value === 'internal',
        userSponsorId: selectedAllocator.value,
        formationId: selectedFormation.value,
        stationType: selectedPeriodicity.value as StationTypes | null,
        responsibleId: coverageResponsibleId.value,
        note: coverageNote.value
      }),
      scheduleId: Number(props.stationDetails?.schedule.id)
    }

    await stationService.patchStationsFromSchedule(payload)

    toast.success(SUCCESS_MESSAGES[coverageMode.value])
    emit('allocationUpdated')
    close()
    succeeded = true
    await stationStore.getListStations()
  } catch (error) {
    console.error('Erro ao submeter a alocação:', error)
    handleAllocationError(error)
  } finally {
    isLoadingSubmit.value = false
  }
  return succeeded
}

function handleAllocationError(error: unknown): void {
  // Médico "coringa" (422 PLACEHOLDER_DOCTOR_BLOCKED): aviso descritivo em vez do toast.
  if (placeholderBlocked.handleError(error, findDoctorTitle(doctors.value, selectedDoctor.value))) {
    focusDoctorOnClose = false
    return
  }
  if (applyConsecutiveHoursError(error)) {
    toast.error('Limite de horas consecutivas excedido. Nenhum plantão foi alterado.')
    return
  }
  if (isPostStationApprovedError(error)) {
    // Defesa em profundidade (RN-07): a avaliação pode ter sido aprovada
    // enquanto o modal estava aberto — o backend recusa a mutação e devolve
    // o code fixo. Modal permanece aberto (sem close()), mesma decisão do
    // guard em update.station.modal.
    //
    // Sem sondagem aqui de propósito: este modal não tem estado de trava
    // preventiva (quem desabilita o acesso é o `stationDetailsModal`), então
    // usa só o helper de mensagem, não o composable.
    toast.error(getPostStationApprovedMessage(error))
    return
  }
  // Códigos de cobertura (Antecipe, check-in, flag desligada…) viram a frase do catálogo.
  const coverageMessage = getCoverageErrorMessage(error)
  if (coverageMessage) {
    toast.error(coverageMessage)
    return
  }
  // Antes: "Erro ao confirmar a alocação." estático.
  notifyError(error, 'Não foi possível confirmar a alocação')
}

const fetchDoctorsWithSearch = async (searchQuery: string) => {
  if (!props.stationDetails?.schedule?.healthUnit?.company?.id) return

  const companyId = props.stationDetails.schedule.healthUnit.company.id

  isLoadingDoctors.value = true
  try {
    await doctorStore.applyFilters(
      {
        inviteStatus: [
          CompanyDoctorInviteStatusEnum.ACCEPTED,
          CompanyDoctorInviteStatusEnum.PENDING
        ],
        companies: [String(companyId)],
        search: searchQuery
      },
      false
    )

    doctors.value = listDoctorsCompany.value.map((doc) => ({
      title: doc.title,
      value: doc.value,
      subtitle: doc.subtitle
    }))
  } catch (error) {
    notifyError(error, 'Não foi possível carregar a lista de médicos')
    console.error(error)
  } finally {
    isLoadingDoctors.value = false
  }
}

function handleSearchUpdate(search: string) {
  clearTimeout(searchDebounceTimer)
  isLoadingDoctors.value = true

  searchDebounceTimer = window.setTimeout(() => {
    fetchDoctorsWithSearch(search)
  }, 500)
}

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
const fetchData = async () => {
  if (
    !props.stationDetails?.schedule?.id ||
    !props.stationDetails?.schedule?.healthUnit?.company?.id
  ) {
    return
  }

  let defaultDay = 'seg'
  let defaultWeek = 'A'

  if (props.stationDetails && props.stationDetails.startHour) {
    try {
      const date = new Date(props.stationDetails.startHour)
      if (!isNaN(date.getTime())) {
        const dayIndex = date.getDay()
        const foundKey = (Object.keys(dayMapping) as Array<keyof typeof dayMapping>).find(
          (key) => dayMapping[key] === dayIndex
        )
        if (foundKey) {
          defaultDay = String(foundKey)
        }

        const dayOfMonth = date.getDate()
        const weekIndex = Math.floor((dayOfMonth - 1) / 7)

        const weekLetters = ['A', 'B', 'C', 'D', 'E']
        if (weekIndex >= 0 && weekIndex < weekLetters.length) {
          defaultWeek = weekLetters[weekIndex]
        }
      }
    } catch (e) {
      console.error('Erro ao calcular data padrão da station:', e)
    }
  }

  const scheduleId = props.stationDetails.schedule.id
  const companyId = props.stationDetails.schedule.healthUnit.company.id

  isLoadingDoctors.value = true
  try {
    await doctorStore.applyFilters(
      {
        inviteStatus: [
          CompanyDoctorInviteStatusEnum.ACCEPTED,
          CompanyDoctorInviteStatusEnum.PENDING
        ],
        companies: [String(companyId)],
        search: ''
      },
      false
    )
    doctors.value = listDoctorsCompany.value.map((doc) => ({
      title: doc.title,
      value: doc.value,
      subtitle: doc.subtitle
    }))
  } catch (error) {
    notifyError(error, 'Não foi possível carregar a lista de médicos')
    console.error(error)
  } finally {
    isLoadingDoctors.value = false
  }

  isLoadingFormations.value = true
  try {
    const formationRes = await new DsPaymentFormationService().getByScheduleId(scheduleId)
    formations.value = formationRes.data.map((item) => ({
      title: item.name,
      value: item.id
    }))
  } catch (error) {
    notifyError(error, 'Não foi possível carregar as formações')
    console.error(error)
  } finally {
    isLoadingFormations.value = false
  }

  isLoadingAllocators.value = true
  try {
    const allocatorRes = await new ScheduleUnitService().stationCreatingUsers(scheduleId)

    allocators.value = allocatorRes.map((user) => ({
      title: user.name,
      value: user.id
    }))
  } catch (error) {
    notifyError(error, 'Não foi possível carregar a lista de alocadores')
    console.error(error)
  } finally {
    isLoadingAllocators.value = false
  }

  if (props.mode === 'change' && props.stationDetails?.doctorStation) {
    const ds = props.stationDetails.doctorStation
    const incomingId = ds.doctor?.id ? String(ds.doctor.id) : null
    const isInList = !!incomingId && doctors.value.some((d) => d.value === incomingId)

    selectedDoctor.value = isInList ? incomingId : null

    if (incomingId && !isInList) {
      toast.warning(
        'Esta vaga não tem médico válido alocado. Selecione um médico para fazer a alocação.'
      )
    }

    selectedFormation.value = ds.dsPaymentDoctorFormation?.id || null
    selectedTeam.value = ds.ourTeam ? 'internal' : 'external'
    selectedAllocator.value = ds.userSponsor?.id || null
    selectedPeriodicity.value = ds.type
    selectedRecurrence.value = 'unique'
    selectedRepetition.value = 'end_scale'
    startDate.value = null
  }

  coverageMode.value = resolveInitialCoverage()
  coverageResponsibleId.value = null
  coverageNote.value = ''
  selectedResponsibleName.value = null
  if (coverageMode.value === CoverageMode.UNIDENTIFIED) {
    coverageResponsibleId.value = originCoverage.value.responsibleId
    coverageNote.value = originCoverage.value.note ?? ''
    selectedResponsibleName.value = originCoverage.value.responsibleName
  }

  selectedWeeks.value = [defaultWeek]
  selectedDay.value = [defaultDay]
}

function close() {
  emit('closeModal')
}

watch(
  () => props.stationDetails,
  (newDetails) => {
    if (newDetails && props.showModal) {
      fetchData()
    }
  },
  { immediate: true, deep: true }
)

watch(
  () => props.showModal,
  (newValue) => {
    isThisModalVisible.value = newValue
    showShiftList.value = false
    shifts.value = []
    totalShiftsCount.value = 0
    openShiftsCount.value = 0
    closedShiftsCount.value = 0
    conflictShiftsCount.value = 0
    isTransitionModalOpen.value = false
    if (!newValue) {
      isExpandedTableModalOpen.value = false
    } else if (props.stationDetails) {
      selectedRepetition.value = 'end_scale'
      fetchData()
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalVue, {
      modalActive: isThisModalVisible.value,
      onClose: close,
      hasHeaderBorder: true,
      hasFooterBorder: true
    }, {
      header: _withCtx(() => [
        _createVNode(ActionModalHeader, {
          "station-details": __props.stationDetails,
          title: modalTitle.value
        }, null, 8, ["station-details", "title"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          (!showShiftList.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(OutlineButton, {
                  height: "48px",
                  color: "grey",
                  onClick: close,
                  class: "w-full md:w-auto"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancelar ")
                  ]),
                  _: 1
                }),
                _createVNode(FilledButton, {
                  height: "48px",
                  color: "primary",
                  onClick: handleViewDoctorStations,
                  loading: isLoadingShifts.value,
                  disabled: !isViewShiftsButtonEnabled.value,
                  class: "w-full md:w-auto"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ver plantões ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (totalShiftsCount.value > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(OutlineButton, {
                        height: "48px",
                        color: "grey",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (showShiftList.value = false)),
                        class: "w-full md:w-auto"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Voltar ")
                        ]),
                        _: 1
                      }),
                      _createVNode(FilledButton, {
                        height: "48px",
                        color: "primary",
                        onClick: submitAllocation,
                        loading: isLoadingSubmit.value,
                        disabled: _unref(hasConsecutiveHoursViolations) || isSubmitBlocked.value,
                        class: "w-full md:w-auto",
                        "data-testid": "management-doctor-submit"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(submitLabel.value), 1)
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createVNode(FilledButton, {
                        height: "48px",
                        color: "primary",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (showShiftList.value = false)),
                        class: "w-full md:w-auto"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Voltar ")
                        ]),
                        _: 1
                      })
                    ]))
              ], 64))
        ])
      ]),
      default: _withCtx(() => [
        (isLoadingSubmit.value)
          ? (_openBlock(), _createBlock(Spinner, {
              key: 0,
              color: "primary",
              size: "5rem",
              width: "0.5rem",
              class: "absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-50"
            }))
          : _createCommentVNode("", true),
        (!showShiftList.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (scheduleSupports.value)
                ? (_openBlock(), _createBlock(CoverageModeSelector, {
                    key: 0,
                    modelValue: coverageMode.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((coverageMode).value = $event)),
                    "allow-unidentified": allowUnidentified.value,
                    "unidentified-locked": _unref(unidentifiedLocked),
                    "can-open-schedule-settings": _unref(canOpenScheduleSettings),
                    onOpenScheduleSettings: _cache[1] || (_cache[1] = ($event: any) => (_unref(openScheduleSettings)(close)))
                  }, null, 8, ["modelValue", "allow-unidentified", "unidentified-locked", "can-open-schedule-settings"]))
                : _createCommentVNode("", true),
              (coverageMode.value === _unref(CoverageMode).UNIDENTIFIED)
                ? (_openBlock(), _createBlock(CoverageResponsibleField, {
                    key: 1,
                    "responsible-id": coverageResponsibleId.value,
                    "onUpdate:responsibleId": _cache[2] || (_cache[2] = ($event: any) => ((coverageResponsibleId).value = $event)),
                    note: coverageNote.value,
                    "onUpdate:note": _cache[3] || (_cache[3] = ($event: any) => ((coverageNote).value = $event)),
                    "health-unit-id": props.stationDetails?.schedule?.healthUnit?.id ?? null,
                    "health-unit-name": props.stationDetails?.schedule?.healthUnit?.name ?? null,
                    "fallback-name": originCoverage.value.responsibleName,
                    "onUpdate:responsibleName": _cache[4] || (_cache[4] = ($event: any) => (selectedResponsibleName.value = $event))
                  }, null, 8, ["responsible-id", "note", "health-unit-id", "health-unit-name", "fallback-name"]))
                : _createCommentVNode("", true),
              (isDoctorTarget.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_v_autocomplete, {
                      "model-value": selectedDoctor.value,
                      "onUpdate:modelValue": onDoctorSelected,
                      items: doctors.value,
                      label: "Médico",
                      variant: "outlined",
                      color: "primary20",
                      density: "comfortable",
                      "item-title": "title",
                      "item-value": "value",
                      loading: isLoadingDoctors.value,
                      "onUpdate:search": handleSearchUpdate,
                      clearable: "",
                      "hide-details": "",
                      "no-data-text": isLoadingDoctors.value ? 'Carregando...' : 'Nenhum médico encontrado',
                      "data-testid": "management-doctor-select"
                    }, {
                      item: _withCtx(({ props, item }) => [
                        _createVNode(_component_v_list_item, _mergeProps(props, {
                          title: item?.raw?.title,
                          subtitle: item?.raw?.subtitle
                        }), null, 16, ["title", "subtitle"])
                      ]),
                      _: 1
                    }, 8, ["model-value", "items", "loading", "no-data-text"]),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_v_autocomplete, {
                        modelValue: selectedFormation.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedFormation).value = $event)),
                        items: formations.value,
                        label: "Formação",
                        variant: "outlined",
                        color: "primary20",
                        density: "comfortable",
                        "item-title": "title",
                        "item-value": "value",
                        loading: isLoadingFormations.value,
                        clearable: "",
                        "hide-details": "",
                        "no-data-text": "Nenhuma formação encontrada"
                      }, null, 8, ["modelValue", "items", "loading"]),
                      _createVNode(_component_v_autocomplete, {
                        modelValue: selectedTeam.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedTeam).value = $event)),
                        items: teams.value,
                        label: "Equipe",
                        variant: "outlined",
                        color: "primary20",
                        density: "comfortable",
                        "item-title": "title",
                        "item-value": "value",
                        loading: isLoading.value,
                        clearable: "",
                        "hide-details": "",
                        "no-data-text": "Nenhuma equipe encontrada"
                      }, null, 8, ["modelValue", "items", "loading"])
                    ]),
                    _createVNode(_component_v_autocomplete, {
                      modelValue: selectedAllocator.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedAllocator).value = $event)),
                      items: allocators.value,
                      label: "Médico escalado por",
                      variant: "outlined",
                      color: "primary20",
                      density: "comfortable",
                      "item-title": "title",
                      "item-value": "value",
                      loading: isLoadingAllocators.value,
                      clearable: "",
                      "hide-details": "",
                      "no-data-text": "Nenhum médico encontrado"
                    }, null, 8, ["modelValue", "items", "loading"])
                  ], 64))
                : _createCommentVNode("", true),
              (coverageMode.value !== _unref(CoverageMode).OPEN)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(periodicity), (opt) => {
                        return (_openBlock(), _createBlock(SelectableCard, {
                          key: opt.value,
                          title: opt.title,
                          description: opt.description,
                          selected: selectedPeriodicity.value === opt.value,
                          onClick: ($event: any) => (selectedPeriodicity.value = opt.value),
                          class: "!flex"
                        }, null, 8, ["title", "description", "selected", "onClick"]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_autocomplete, {
                  modelValue: selectedRecurrence.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedRecurrence).value = $event)),
                  items: _unref(recurrence),
                  label: "Recorrência da alocação",
                  variant: "outlined",
                  color: "primary20",
                  density: "comfortable",
                  "item-title": "title",
                  "item-value": "value",
                  loading: isLoading.value,
                  clearable: "",
                  "hide-details": "",
                  "no-data-text": "Nenhuma recorrência encontrada"
                }, null, 8, ["modelValue", "items", "loading"]),
                _createElementVNode("p", _hoisted_7, _toDisplayString(computedRecurrenceDescription.value), 1),
                (selectedRecurrence.value === 'abcde')
                  ? (_openBlock(), _createBlock(OptionSelect, {
                      key: 0,
                      label: "Selecione as semanas do mês a serem fixadas",
                      options: _unref(weekOptions),
                      modelValue: selectedWeeks.value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedWeeks).value = $event)),
                      multiple: ""
                    }, null, 8, ["options", "modelValue"]))
                  : _createCommentVNode("", true),
                (selectedRecurrence.value !== 'unique')
                  ? (_openBlock(), _createBlock(OptionSelect, {
                      key: 1,
                      label: "Selecione os dias da semana a serem alocados",
                      options: _unref(dayOptions),
                      modelValue: selectedDay.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedDay).value = $event)),
                      multiple: ""
                    }, null, 8, ["options", "modelValue"]))
                  : _createCommentVNode("", true),
                (selectedRecurrence.value !== 'unique')
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", {
                            class: _normalizeClass(selectedRepetition.value === 'personalized' ? 'w-3/4' : 'w-full')
                          }, [
                            _createVNode(_component_v_autocomplete, {
                              modelValue: selectedRepetition.value,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedRepetition).value = $event)),
                              items: _unref(repetition),
                              label: "Se repete até",
                              variant: "outlined",
                              color: "primary20",
                              density: "comfortable",
                              "item-title": "title",
                              "item-value": "value",
                              loading: isLoading.value,
                              "hide-details": ""
                            }, null, 8, ["modelValue", "items", "loading"])
                          ], 2),
                          (selectedRepetition.value === 'personalized')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_unref(DatePicker), {
                                  modelValue: startDate.value,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((startDate).value = $event)),
                                  "max-date": 
                  props.stationDetails?.schedule.endDate
                    ? new Date(props.stationDetails?.schedule.endDate)
                    : null
                ,
                                  "initial-page": _unref(initialPage),
                                  locale: "pt-BR",
                                  masks: { input: 'DD/MM/YYYY' }
                                }, {
                                  default: _withCtx(({ inputValue, inputEvents }) => [
                                    _createVNode(_component_v_text_field, _mergeProps({
                                      label: "Data final",
                                      "model-value": inputValue
                                    }, _toHandlers(inputEvents), {
                                      color: "primary20",
                                      variant: "outlined",
                                      density: "comfortable",
                                      "prepend-inner-icon": _unref(mdiCalendar),
                                      readonly: "",
                                      "hide-details": ""
                                    }), null, 16, ["model-value", "prepend-inner-icon"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "max-date", "initial-page"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (totalShiftsCount.value > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(summaryText.value), 1),
                    (coveragePlan.value.hasContract)
                      ? (_openBlock(), _createBlock(CoveragePreviewSummary, {
                          key: 0,
                          plan: coveragePlan.value,
                          "target-doctor-name": isDoctorTarget.value ? computedDoctorDetails.value.name : null
                        }, null, 8, ["plan", "target-doctor-name"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                      (isDoctorTarget.value)
                        ? (_openBlock(), _createBlock(CardDutyWithDoctor, {
                            key: 0,
                            formation: computedDoctorDetails.value.formation,
                            team: computedDoctorDetails.value.team,
                            dutyLabel: 
              selectedPeriodicity.value === 'COBERTURA'
                ? 'Cobertura'
                : selectedPeriodicity.value === 'FIXO'
                  ? 'Fixo'
                  : ''
            ,
                            doctorName: computedDoctorDetails.value.name,
                            doctorCrm: computedDoctorDetails.value.crm,
                            active: true,
                            layout: 'simple',
                            npsScore: __props.stationDetails?.doctorNpsScore?.npsScore,
                            avatarUrl: __props.stationDetails?.doctorStation?.doctor?.user?.avatarUrl
                          }, null, 8, ["formation", "team", "dutyLabel", "doctorName", "doctorCrm", "npsScore", "avatarUrl"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, [
                        (shouldShowInitialStationWarning.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                              _createTextVNode(" A alocação configurada não altera o plantão selecionado inicialmente"),
                              _createElementVNode("span", _hoisted_16, "#" + _toDisplayString(__props.stationDetails?.doctorStation?.id), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (hasConflictingStations.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                              _createVNode(_component_v_icon, {
                                icon: _unref(mdiAlertCircleOutline),
                                color: '#DA1E28',
                                class: "w-5 h-5 shrink-0"
                              }, null, 8, ["icon"]),
                              _hoisted_18
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("span", null, _toDisplayString(__props.stationDetails?.schedule?.healthUnit?.company?.name || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("span", null, _toDisplayString(__props.stationDetails?.schedule?.name || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("span", null, _toDisplayString(__props.stationDetails?.schedule?.healthUnit?.name || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("span", null, _toDisplayString(__props.stationDetails?.position?.name || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("span", null, _toDisplayString(__props.stationDetails?.shift?.name || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createElementVNode("span", null, _toDisplayString(__props.stationDetails?.timezone || 'N/A'), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createVNode(ManagementDoctorTable, {
                      headers: previewHeaders.value,
                      items: limitedFormattedShifts.value,
                      expandable: "",
                      onExpand: _unref(handleExpandTable)
                    }, null, 8, ["headers", "items", "onExpand"]),
                    _createVNode(ConsecutiveHoursBlockAlert, {
                      violations: _unref(consecutiveHoursViolations),
                      bulk: true
                    }, null, 8, ["violations"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createVNode(_component_v_icon, {
                      class: "w-24 h-24 mb-4",
                      icon: _unref(mdiAlertCircleOutline),
                      color: '#DA1E28'
                    }, null, 8, ["icon"]),
                    _hoisted_33
                  ]))
            ]))
      ]),
      _: 1
    }, 8, ["modalActive"]),
    _createVNode(ExpandedTableModal, {
      showModal: isExpandedTableModalOpen.value,
      headers: previewHeaders.value,
      items: formattedShifts.value,
      mode: __props.mode === 'change' ? 'change' : 'allocate',
      title: modalTitle.value,
      "conflict-count": conflictShiftsCount.value,
      "open-count": coveragePlan.value.hasContract ? coveragePlan.value.counts.OPEN : openShiftsCount.value,
      "closed-count": coveragePlan.value.hasContract ? coveragePlan.value.counts.DOCTOR : closedShiftsCount.value,
      "unidentified-count": 
      coveragePlan.value.hasContract ? coveragePlan.value.counts.UNIDENTIFIED : unregisteredShiftsCount.value
    ,
      "blocked-count": coveragePlan.value.hasContract ? coveragePlan.value.counts.BLOCKED : null,
      "total-count": totalShiftsCount.value,
      onClose: _unref(handleCloseExpandedTable)
    }, null, 8, ["showModal", "headers", "items", "mode", "title", "conflict-count", "open-count", "closed-count", "unidentified-count", "blocked-count", "total-count", "onClose"]),
    _createVNode(CoverageTransitionConfirmModal, {
      "show-modal": isTransitionModalOpen.value,
      summary: transitionSummary.value,
      "context-label": transitionContextLabel.value,
      "responsible-name": selectedResponsibleName.value,
      loading: isLoadingSubmit.value,
      onConfirm: handleTransitionConfirm,
      onCancel: _cache[15] || (_cache[15] = ($event: any) => (isTransitionModalOpen.value = false))
    }, null, 8, ["show-modal", "summary", "context-label", "responsible-name", "loading"]),
    (_unref(placeholderBlocked).isOpen.value)
      ? (_openBlock(), _createBlock(PlaceholderDoctorBlockedModal, {
          key: 0,
          modelValue: _unref(placeholderBlocked).isOpen.value,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(placeholderBlocked).isOpen.value) = $event)),
          "doctor-name": _unref(placeholderBlocked).doctorName.value,
          "allow-unidentified": allowUnidentified.value,
          onUseUnidentified: onUseUnidentified
        }, null, 8, ["modelValue", "doctor-name", "allow-unidentified"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})